import { useMutation, useQueryClient } from '@tanstack/react-query';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { saveTableViewColumns } from '../data-provider/table-view-columns';
import type { SaveTableViewColumnsData } from '../data-provider/table-view-columns/api';

export interface UseSaveTableViewColumnsOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useSaveTableViewColumns = (options?: UseSaveTableViewColumnsOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SaveTableViewColumnsData) => saveTableViewColumns(data),
    onError: (error: Error) => {
      showNotification({
        message: 'Failed to save Loss and Damage claims columns Options',
        type: NOTIFICATION_TYPES.ERROR,
      });
      options?.onError?.(error);
    },
    onSuccess: (_, variables) => {
      // Update the cache with the new columns
      queryClient.setQueryData(['claims-loss-and-damage-table-view-columns', variables.gridName], (oldData: any) => {
        if (!oldData) {
          return oldData;
        }
        return variables.columnOptions.map(({ fieldReferenceName, fieldReferenceValue }) => ({
          columnName: fieldReferenceName,
          columnValue: fieldReferenceValue,
        }));
      });

      showNotification({
        message: 'Successfully saved Loss and Damage claims columns Options',
        type: NOTIFICATION_TYPES.SUCCESS,
      });

      if (options?.onSuccess) {
        options.onSuccess();
      } else {
        // No-op
      }
    },
  });
};
